module.exports = __webpack_public_path__ + "img/moishop_portfolio_2.4242779e.png";